import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  vendorID: 0,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'type',
      label: 'Type',
      aria: 'Type',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'description',
      label: 'Description',
      aria: 'Description',
      width: '15%',
      sortable: true,
      searchable: true
    },
    {
      field: 'locationDescription',
      label: 'Location',
      aria: 'Location',
      width: '15%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      label: 'Date Created',
      aria: 'Date Created',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'completedDate',
      label: 'Date Completed',
      aria: 'Date Completed',
      width: '10%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
